<template>
  <div>
    <a-tabs :active-key="activeKey" @change="changeTab">
      <a-tab-pane
        v-for="item in tabs"
        :key="item.routeName"
        :tab="item.tabName"
      >
        <router-view v-if="activeKey===item.routeName" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
export default {
  name: 'CardRiskManagesShowTab',
  data() {
    return {
      activeKey: '',
      tabs: [
        { routeName: 'card_risk_manages_bind_imei', tabName: '机卡分离', permission: 'card_risk_manages/bind_imei' },
        { routeName: 'card_risk_manages_bind_area', tabName: '区域限制', permission: 'card_risk_manages/bind_area' }
      ]
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.activeKey = this.$route.name
      }
    }
  },
  created() {
    this.activeKey = this.$route.name
  },
  methods: {
    changeTab(activeKey) {
      this.activeKey = activeKey
      this.$router.push({ name: activeKey })
    }
  }
}
</script>
